import { cn } from '@/lib/utils'

/**
 * Eyebrow + headline + optional lead, laid out as the design references do:
 * a wide headline column against a narrower lead, baseline-aligned, with
 * 55px of clearance beneath (the `.section-head` class in globals.css).
 *
 * Extracted 2026-08-08. The same unit previously existed in three shapes —
 * a local component in pricing, a Kicker/SectionHeading pair in platform,
 * and an inline flex row repeated three times in about.
 *
 * `tone='accent'` is for section heads sitting on a magenta band, where the
 * eyebrow and lead need the inverted alphas rather than the brand colours.
 */
export function SectionHead({
  eyebrow,
  title,
  lead,
  tone = 'default',
  className,
}: {
  eyebrow: string
  title: React.ReactNode
  lead?: React.ReactNode
  tone?: 'default' | 'accent'
  className?: string
}) {
  const accent = tone === 'accent'
  return (
    <div className={cn('section-head', className)}>
      <div>
        <span
          className={cn(
            'instrument-label block mb-[18px]',
            accent && 'text-white/70'
          )}
        >
          {eyebrow}
        </span>
        <h2 className='thesis-headline'>{title}</h2>
      </div>
      {lead && (
        <p
          className={cn(
            'section-lead',
            accent ? 'text-white/80' : 'text-muted-foreground'
          )}
        >
          {lead}
        </p>
      )}
    </div>
  )
}

export default SectionHead
